import { createPromiseAction } from 'redux-saga-promise-actions';

import { Banner, BannerType } from 'store/types';

export const getBanners = createPromiseAction('GET_BANNERS', 'GET_BANNERS_SUCCEEDED', 'GET_BANNERS_FAILURE')<
  BannerType,
  Array<Banner>,
  undefined
>();
